// @ts-ignore
import { currencyObject } from '../common/types/types'
import { TermLengthType } from '../types/types'

import InvestmentSummaryCard from './InvestmentSummaryCard'
import AccountCard from './AccountCard'

interface FrontPageDataProps {
   getString: (key: string, fallback?: string) => string
   differenceQuote: boolean
   currencyObject: currencyObject
   currencyObjectUSD: currencyObject
   isForeignCurrencyQuote: boolean
   payrollUsdMonthlyTotal: number
   payrollUsdOneTimeTotal: number
   payrollUsdPreviousMonthlyTotal: number
   payrollUsdMonthlyDifference: number
   payrollUsdPreDiscountTotal: number
   payrollUsdFirstYearSavings: number
   payrollUsdFirstYearTotal: number
   employeeCount: number
   firstYearTotal: number
   oneTimeFee: number
   ongoingMonthlyTotal: number
   newAnnualTotal: number
   previousMonthlyTotal: number
   previousAnnualTotal: number
   monthlyDifference: number
   annualDifference: number
   listPriceTotal: number
   totalDiscount: number
   accountName: string
   clientEmployeeName: string
   clientEmployeeEmail: string
   bhrEmployeeName: string
   bhrEmployeeEmail: string
   termLengthObject: TermLengthType | null
   activationDate: string
   formType: number
   prepayLengthMonths: number
}

export default function FrontPageData({
   getString,
   differenceQuote,
   currencyObject,
   currencyObjectUSD,
   isForeignCurrencyQuote,
   payrollUsdMonthlyTotal,
   payrollUsdOneTimeTotal,
   payrollUsdPreviousMonthlyTotal,
   payrollUsdMonthlyDifference,
   payrollUsdPreDiscountTotal,
   payrollUsdFirstYearSavings,
   payrollUsdFirstYearTotal,
   employeeCount,
   firstYearTotal,
   oneTimeFee,
   ongoingMonthlyTotal,
   newAnnualTotal,
   previousMonthlyTotal,
   previousAnnualTotal,
   monthlyDifference,
   annualDifference,
   listPriceTotal,
   totalDiscount,
   accountName,
   clientEmployeeName,
   clientEmployeeEmail,
   bhrEmployeeName,
   bhrEmployeeEmail,
   termLengthObject,
   activationDate,
   formType,
   prepayLengthMonths,
}: FrontPageDataProps) {
   return (
      <div className='frontPageData frontPageDataCards'>
         <InvestmentSummaryCard
            getString={getString}
            differenceQuote={differenceQuote}
            currencyObject={currencyObject}
            currencyObjectUSD={currencyObjectUSD}
            isForeignCurrencyQuote={isForeignCurrencyQuote}
            payrollUsdMonthlyTotal={payrollUsdMonthlyTotal}
            payrollUsdOneTimeTotal={payrollUsdOneTimeTotal}
            payrollUsdPreviousMonthlyTotal={payrollUsdPreviousMonthlyTotal}
            payrollUsdMonthlyDifference={payrollUsdMonthlyDifference}
            payrollUsdPreDiscountTotal={payrollUsdPreDiscountTotal}
            payrollUsdFirstYearSavings={payrollUsdFirstYearSavings}
            payrollUsdFirstYearTotal={payrollUsdFirstYearTotal}
            previousMonthlyTotal={previousMonthlyTotal}
            previousAnnualTotal={previousAnnualTotal}
            newMonthlyTotal={ongoingMonthlyTotal}
            newAnnualTotal={newAnnualTotal}
            monthlyDifference={monthlyDifference}
            annualDifference={annualDifference}
            oneTimeFee={oneTimeFee}
            listPriceTotal={listPriceTotal}
            totalDiscount={totalDiscount}
            firstYearTotal={firstYearTotal}
         />
         <AccountCard
            getString={getString}
            accountName={accountName}
            clientEmployeeName={clientEmployeeName}
            clientEmployeeEmail={clientEmployeeEmail}
            bhrEmployeeName={bhrEmployeeName}
            bhrEmployeeEmail={bhrEmployeeEmail}
            termLengthObject={termLengthObject}
            activationDate={activationDate}
            employeeCount={employeeCount}
            formType={formType}
            prepayLengthMonths={prepayLengthMonths}
         />
      </div>
   )
}
